// PaymentFailed.jsx
import React from "react";
import "./payment.css";

export default function PaymentFailed() {
  return (
    <div className="payment-container failed">
      <img src="/belmarket.png" alt="BelMarket Logo" className="logo" />

      <h1>Paiement échoué ❌</h1>
      <p>Une erreur est survenue. Veuillez réessayer.</p>
      {/*
  
      <button onClick={() => window.location.reload()} className="btn">
        Réessayer
      </button> */}
    </div>
  );
}
